import { Box, Stack, styled } from '@ltvco/refresh-lib/theme';

export const GridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '20px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const ListContainer = styled(Stack)({
  gap: '20px',
  width: '100%',
});
